export class Questionnaire {
  hasExistingERCClaim2020
  ercAmount2020
  hasExistingERCClaim2021
  ercAmount2021
  irsFilingType
  estimatedFilingDate
  receivedChecks
  numOfChecks
  processingCompany
  existingTaxLiabilities
  liabilityAmount
  title
  numOfEmployees
  ein
  street
  city
  state
  zip

  constructor(applicationQuestionnaire = {}) {
    this.hasExistingERCClaim2020 = applicationQuestionnaire.hasExistingERCClaim2020 ? String(applicationQuestionnaire.hasExistingERCClaim2020) : ''
    this.ercAmount2020 = applicationQuestionnaire.ercAmount2020 ? String(applicationQuestionnaire.ercAmount2020) : ''
    this.hasExistingERCClaim2021 = applicationQuestionnaire.hasExistingERCClaim2021 ? String(applicationQuestionnaire.hasExistingERCClaim2021) : ''
    this.ercAmount2021 = applicationQuestionnaire.ercAmount2021 ? String(applicationQuestionnaire.ercAmount2021) : ''
    this.irsFilingType = applicationQuestionnaire.irsFilingType ? String(applicationQuestionnaire.irsFilingType) : ''
    this.estimatedFilingDate = applicationQuestionnaire.estimatedFilingDate ? String(applicationQuestionnaire.estimatedFilingDate) : ''
    this.receivedChecks = applicationQuestionnaire.receivedChecks ? String(applicationQuestionnaire.receivedChecks) : ''
    this.numOfChecks = applicationQuestionnaire.numOfChecks ? String(applicationQuestionnaire.numOfChecks) : ''
    this.processingCompany = applicationQuestionnaire.processingCompany ? String(applicationQuestionnaire.processingCompany) : ''
    this.existingTaxLiabilities = applicationQuestionnaire.existingTaxLiabilities ? String(applicationQuestionnaire.existingTaxLiabilities) : ''
    this.liabilityAmount = applicationQuestionnaire.liabilityAmount ? String(applicationQuestionnaire.liabilityAmount) : ''
    this.title = applicationQuestionnaire.title ? String(applicationQuestionnaire.title) : ''
    this.numOfEmployees = applicationQuestionnaire.numOfEmployees ? String(applicationQuestionnaire.numOfEmployees) : ''
    this.ein = applicationQuestionnaire.ein ? String(applicationQuestionnaire.ein) : ''
    this.street = applicationQuestionnaire.street ? String(applicationQuestionnaire.street) : ''
    this.city = applicationQuestionnaire.city ? String(applicationQuestionnaire.city) : ''
    this.state = applicationQuestionnaire.state ? String(applicationQuestionnaire.state) : ''
    this.zip = applicationQuestionnaire.zip ? String(applicationQuestionnaire.zip) : ''
  }
}